module.exports = __webpack_public_path__ + "static/pro3.png";